export default __webpack_public_path__ + "static/media/hhh.7c873cce.png";